
// import MetricCard from './MetricCard';
import FinancialChart from './FinancialChart';
import { MetricsOverview } from './MetricsOverview';
import { FinancialDataMatric } from "../types/FinancialInterface";

type FinancialDatapops = {
  financialDatas: FinancialDataMatric[] | [],
};


const FinancialDashboard :React.FC<FinancialDatapops> = ({financialDatas}) => {


  // Prepare chart data
  const chartData = financialDatas.map(item => ({
    
    year: item.year.split('-')[0],
    Revenue: item.netRevenue ?? item.net_revenue ?? 0,
    EBITDA: item.ebitda ?? 0,
    PAT: Math.abs(item.pat ?? 0) // Use absolute value for better chart visualization
  }));

  const sortedChartData = chartData.sort((a, b) => Number(a.year) - Number(b.year));

  return (
    <div className=" from-primary-50 via-primary-25 to-white p-1">
      <div className="max-w-7xl mx-auto">
       
        <div className="mb-8 text-center">
        <MetricsOverview financialData={financialDatas} />
        </div>

        {/* Chart Section */}
        <div className="">
          <FinancialChart data={sortedChartData} />
        </div>
      </div>
    </div>
  );
};

export default FinancialDashboard;